import React from 'react'

import StyledTitle from '@components/Typography/StyledTitle'

import { StyledTitleType } from '@contracts/Components/StyledTitle'

import * as styles from './SectionTitle.module.scss'

interface Props {
	title: StyledTitleType
	className?: string
}

const SectionTitle = (props: Props) => {
	const classNames = [styles.title]

	if (props.className) {
		classNames.push(props.className)
	}

	return <StyledTitle tag="h2" data={props.title} className={classNames.join(' ')} />
}

export default SectionTitle
